import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CaptchaComponent } from '@freelancer/captcha';
import { ComponentsModule } from '@freelancer/components';
import { PipesModule } from '@freelancer/pipes';
import { PwaModule } from '@freelancer/pwa';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { TwoFactorOptionsComponent } from 'app/login-signup/login/two-factor-options/two-factor-options.component';
import { LoginSignupButtonsModule } from 'app/login-signup/login-signup-buttons.module';
import { LoginSignupErrorsModule } from 'app/login-signup/login-signup-errors/login-signup-errors.module';
import { NewAccountProgressBarComponent } from '../steps/new-account-progress-bar.component';
import { NewAccountLoginCredentialsComponent } from './credentials/new-account-login-credentials.component';
import { NewAccountResetPasswordFormComponent } from './reset-password/new-account-reset-password-form.component';
import { NewAccountResetPasswordSuccessComponent } from './reset-password/new-account-reset-password-success.component';
import { NewAccountSsoLinkComponent } from './sso-link/new-account-sso-link.component';
import { NewAccountTwoFactorFormComponent } from './two-factor-form/new-account-two-factor-form.component';

@NgModule({
  imports: [
    CaptchaComponent,
    CommonModule,
    ComponentsModule,
    LoginSignupButtonsModule,
    LoginSignupErrorsModule,
    NewAccountProgressBarComponent,
    PipesModule,
    PwaModule,
    TrackingModule,
    TwoFactorOptionsComponent,
    UiModule,
  ],
  exports: [
    NewAccountLoginCredentialsComponent,
    NewAccountResetPasswordFormComponent,
    NewAccountResetPasswordSuccessComponent,
    NewAccountSsoLinkComponent,
    NewAccountTwoFactorFormComponent,
  ],
  declarations: [
    NewAccountLoginCredentialsComponent,
    NewAccountResetPasswordFormComponent,
    NewAccountResetPasswordSuccessComponent,
    NewAccountSsoLinkComponent,
    NewAccountTwoFactorFormComponent,
  ],
})
export class NewAccountLoginModule {}
